import { render, staticRenderFns } from "./PowerpointPresenting.vue?vue&type=template&id=53c6331e&scoped=true"
import script from "./PowerpointPresenting.vue?vue&type=script&lang=js"
export * from "./PowerpointPresenting.vue?vue&type=script&lang=js"
import style0 from "./PowerpointPresenting.vue?vue&type=style&index=0&id=53c6331e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6331e",
  null
  
)

export default component.exports